interface Langs {
  [key: string]: {
    ko: string
    en: string
  }
}
export const langs: Langs = {
  headerinDJ: {
    ko: 'inDJ 스트리밍',
    en: 'inDJ Streaming',
  },
  company: {
    ko: '회사소개',
    en: 'About inDJ',
  },
  contact: {
    ko: '문의하기',
    en: 'Contact',
  },
  technical: {
    ko: '기술제휴',
    en: 'Technical partnership',
  },
  tech: {
    ko: '기술',
    en: 'Technology',
  },
  voucher: {
    ko: 'AI 바우처',
    en: 'AI voucher',
  },
  service: {
    ko: '서비스 소개',
    en: 'Service',
  },
  recruitment: {
    ko: '채용정보',
    en: 'Jop Posting',
  },
  indj: {
    ko: 'inDJ',
    en: 'inDJ',
  },
  flda: {
    ko: 'FL DA',
    en: 'FL DA',
  },
  more: {
    ko: '더보기',
    en: 'More',
  },
  top: {
    ko: '맨 위로',
    en: 'Top',
  },
}
